<template>
  <div class="d-flex bg-white py-3">
      <img class="me-auto" width="50" src="@/assets/images/star-notfy.svg" alt="">
      <div class="d-flex me-auto flex-column">
          <h5 class="fs-6 fw-bold text-dark">تم إعادة تعيين البطاقة الإفتراضية</h5>
          <span class="fs-14px text-secondary">نص عربي وهمي يعبر عن شيء تم ولكن لم يتم</span>
      </div>
  </div>
</template>